import React from 'react';
import styles from './styles.module.css';

const ProTip=props=>{
    const{body}=props;
    return(
        <p className={styles.proContainer}>
            <span className={styles.proText}>Pro tip </span>
            {body()}
        </p>
    )
}

export default ProTip;